import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seccion-home',
  templateUrl: './seccion-home.component.html',
  styleUrls: ['./seccion-home.component.css']
})
export class SeccionHomeComponent implements OnInit {

  

  constructor(
    
  ) { 
    
  }

  ngOnInit() {
  }

}
